import { useEffect, useRef } from 'react';
import {  connectNotificationHub,  getNotificationConnection} from '@/lib/signalR';

export function useRealtimeNotifications(enabled: boolean,  onNotification: (payload: unknown) => void) {
  const callbackRef = useRef(onNotification);
  callbackRef.current = onNotification;

  useEffect(() => {
    if (!enabled) return;

    const conn = getNotificationConnection();

    const handler = (payload: unknown) => {
      callbackRef.current(payload);
    };

    conn.on('NotificationReceived', handler);

    connectNotificationHub().catch(() => {
      // SignalR indisponible :
      // le polling de la Navbar prend le relais.
    });

    return () => {
      // On retire uniquement le listener de ce composant.
      conn.off('NotificationReceived', handler);
    };
  }, [enabled]);
}